var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.filter.values.places.map(function (place){ return place.label; }).join(', '))+" "),_c('b',[_vm._v("("+_vm._s(_vm.filter.values.type)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }